<div fxFlexFill fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="24px">
  <mat-spinner *ngIf="!error" [diameter]="32"></mat-spinner>

  <ng-container *ngIf="error">
    <span class="error">An error occurred generating your Turno account.</span>
    <sbnb-button (clicked)="goBack()">Go back</sbnb-button>
  </ng-container>
</div>
